module.exports = __webpack_public_path__ + "static/media/dashboard-analytics.a32d7a68.png";